export enum OccurrenceStepLabelEnum {
  CALL = 'Abertura de chamado',
  SCREENING = 'Triagem',
  DISPLACEMENT = 'Deslocamento',
  SECOND_DIAGNOSIS = '2ª diagnose',
  REMOVAL = 'Remoção',
  THIRD_DIAGNOSIS = '3ª diagnose',
  FOURTH_DIAGNOSIS = '4ª diagnose',
  ANALYSIS_WARRANTY = 'Análise e garantia',
  CUSTOMER_OK = 'Ok do cliente',
  PARTS = 'Peças',
  PARTS_IN_TRANSIT = 'Peças em trânsito',
  AWAITING_REPAIR = 'Aguardando reparo',
  REPAIR = 'Reparo',
  RELEASE = 'Liberação',
}

export enum OccurrenceStepEnum {
  CALL = 'TICKE',
  SCREENING = 'TRIAG',
  DISPLACEMENT = 'RELOC',
  SECOND_DIAGNOSIS = 'DIAG2',
  REMOVAL = 'REMOC',
  THIRD_DIAGNOSIS = 'DIAG3',
  FOURTH_DIAGNOSIS = 'DIAG4',
  ANALYSIS_WARRANTY = 'ANGAR',
  CUSTOMER_OK = 'OKCLI',
  PARTS = 'PARTS',
  PARTS_IN_TRANSIT = 'PARINTR',
  AWAITING_REPAIR = 'WAITREP',
  REPAIR = 'REPAIR',
  RELEASE = 'RELEASE',
}

export const OccurrenceStepInfoText: Record<OccurrenceStepEnum, string> = {
  [OccurrenceStepEnum.CALL]: 'Início do processo. Identificação dos dados do veículo, cliente, concessionária e tipo de ocorrência. A partir daqui, o tempo de atendimento começa a ser contabilizado.',
  [OccurrenceStepEnum.SCREENING]: 'Abertura da Ordem de Serviço (OS) com base na falha relatada, revisão, manutenção corretiva ou campanha aplicável.',
  [OccurrenceStepEnum.DISPLACEMENT]: 'Etapa exclusiva para ocorrências de socorro mecânico ou guincho. Inicia após confirmação da saída do técnico ou guincho para o local da pane.',
  [OccurrenceStepEnum.SECOND_DIAGNOSIS]: 'Aplicável a chamados de socorro. O mecânico realiza a avaliação técnica no local, com base na falha relatada previamente pelo condutor. Identifica eventuais falhas adicionais.',
  [OccurrenceStepEnum.REMOVAL]: 'Aplicável a chamados de socorro. Diante da impossibilidade de reparação no local, o veículo é removido à concessionária para realização do reparo.',
  [OccurrenceStepEnum.THIRD_DIAGNOSIS]: 'Diagnóstico técnico dentro do Concessionário com uso de arquivo de falhas, ferramentas específicas e mecânico do Concessionário. Define os tempos padrão de reparo, peças necessárias e verifica disponibilidade em estoque.',
  [OccurrenceStepEnum.FOURTH_DIAGNOSIS]: 'Diagnóstico complexo com apoio da estrutura VWCO de Suporte Técnico Avançado(TAS). É aberto um protocolo TAS para apoio especializado.',
  [OccurrenceStepEnum.ANALYSIS_WARRANTY]: 'Avaliação da cobertura técnica de garantia ou contrato de manutenção e definição de Fonte Pagadora (garantia, plano de manutenção, cliente ou concessionário). Pode haver custos para o cliente.',
  [OccurrenceStepEnum.CUSTOMER_OK]: 'Etapa de aprovação do orçamento pelo cliente ou seguradora em casos de sinistro para execução do serviço.',
  [OccurrenceStepEnum.PARTS]: 'Solicitação das peças necessárias para aquele reparo. Requer preenchimento do número de pedido de unidade parada com a identificação do número de peças, descrição. A Área de Peças e Acessórios P&A informa os prazos para atendimento daquele pedido específico e previsão de chegada.',
  [OccurrenceStepEnum.PARTS_IN_TRANSIT]: 'Etapa que contabiliza o tempo de transito do pedido, desde o Armazém de Peças P&A ou do Fornecedor em casos de pedidos DSH. A previsão de chegada deve estar definida.',
  [OccurrenceStepEnum.AWAITING_REPAIR]: 'Com as peças disponíveis no Concessionário, o veículo aguarda disponibilidade box/mecânico da oficina para execução do serviço. Como parte da programação da oficina deve haver uma previsão para início do reparo.',
  [OccurrenceStepEnum.REPAIR]: 'Execução do serviço de manutenção: preventivo, corretivo ou ação de campo. Nesta etapa deve obrigatoriamente ter previsão de liberação ao cliente.',
  [OccurrenceStepEnum.RELEASE]: 'Após testes de oficina e rodagem, o veículo é liberado com aprovação do cliente e encerramento do processo.',
}

export const getOccurrenceStepLabelByStepValue = (stepValue: string) => {
  const key = Object.keys(OccurrenceStepLabelEnum).find(key => OccurrenceStepEnum[key] === stepValue);
  if (!key) return "";
  return OccurrenceStepLabelEnum[key as keyof typeof OccurrenceStepLabelEnum];
}

export const getOccurrenceStepKeyOfValue = (stepValue: string) => {
  const key = Object.keys(OccurrenceStepEnum).find(key => OccurrenceStepEnum[key] === stepValue);
  if (!key) return "";
  return key;
}

export const getOccurrenceStepInfoText = (step: OccurrenceStepEnum) => {
  return OccurrenceStepInfoText[step] || "";
};